module.exports = {
  API_BASE_URL: './sistema/modules/include',
  NODE_ENV: '"production"'
}
